<template>
  <div class="modal info-rec">
    <div class="empty" @click="emits('close')"></div>
    <div class="box">
      <div class="content">
        <div class="close" @click="emits('close')"><i class="fa-solid fa-xmark"></i></div>
        <div class="top-con">
          <div class="itens">
            <div class="icon"></div>
            <span>{{ info.itens }}</span>&nbsp;itens
          </div>
          <div class="image" :style="{backgroundImage: 'url('+info.image_mob+')'}"></div>
          <div class="title">{{ info.mob }}</div>
          <div class="desc">Código do mobi: {{ info.code }}</div>
        </div>
        <div class="text">
          <div class="date">
            Recorde batido em {{ info.time }} por <span>{{ info.recordista }}</span>
          </div>
          <img alt="info.user" :src="info.image">
          <div class="posted">
            <div class="avatar"
                 :style="{backgroundImage: `url('${avatarUrl(info.user, { action: 'std,crr=', direction: 4, headonly: true, img_format: '', dance: '', effect: '', frame_num: 30 })}')`}"></div>
            <div class="user">Atualizado por <span>{{ info.user }}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { getRecordById, avatarUrl } from '@/services/api.js'
import { ref } from 'vue'

const emits = defineEmits(['close'])
const props = defineProps(['id'])

const info = ref([])

async function getInfo() {
  info.value = await getRecordById(props.id) ?? {}
}

getInfo()

</script>

<style scoped>

.modal .box {
  width: 600px;
  max-width: calc(100vw - 32px);
}

.info-rec .content {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0;
  margin: 0;
}

.info-rec .content .close {
  position: absolute;
  right: 5px;
  top: 5px;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  user-select: none;
}

.info-rec .content .itens {
  position: absolute;
  left: 0;
  top: 0;
  width: auto;
  height: 32px;
  background-color: #0D93C6;
  border-radius: 10px 0 10px 0;
  text-align: center;
  line-height: 32px;
  color: #fff;
  font-size: 13px;
  padding: 0 16px;
  display: flex;
  align-items: center;
}

.info-rec .content .itens .icon {
  width: 11px;
  height: 14px;
  background-image: url('../../assets/medal.png');
  background-repeat: no-repeat;
  margin-right: 6px;
}

.info-rec .content .itens span {
  font-weight: 600;
}

.modal .content .top-con {
  width: 100%;
  height: auto;
  border-bottom: 2px solid rgba(0, 0, 0, .08);
  padding: 20px 10px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 10px;
}

.modal .content .top-con .image {
  width: 290px;
  height: 100px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.modal .content .top-con .title,
.modal .content .top-con .desc {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  margin-top: 10px;
}

.modal .content .top-con .desc {
  font-weight: 400;
  font-size: 13px;
  margin-top: 6px;
}

.modal .content .text {
  width: 100%;
  height: auto;
  padding: 10px;
  text-align: center;
  font-weight: 500;
  background: rgb(255, 255, 255);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(232, 232, 232, 1) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  border-radius: 0 0 12px 12px;
}

.modal .content .text img {
  width: calc(100% - 20px);
  max-width: 520px;
  margin: 8px 0 0;
  border-radius: 12px;
  display: block;
}

.modal .content .text .date,
.modal .content .text .posted {
  font-size: 14px;
  width: 100%;
  max-width: 100%;
  padding: 0 16px;
  line-height: 1.4;
  flex-shrink: 0;
}

.modal .content .text .date {
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  min-height: 20px;
  margin-bottom: 4px;
  scrollbar-width: thin;
}

.modal .content .text .posted {
  height: 38px;
  line-height: 36px;
  display: flex;
  justify-content: space-around;
  border-radius: 22px;
  background-color: #fff;
  margin: 20px 0;
  width: auto;
  max-width: 100%;
}

.modal .content .text .posted .avatar {
  width: 36px;
  height: 100%;
  background-position: center -34px;
}

.modal .content .text .posted .user {
  margin-left: 10px;
}

.modal .content .text .posted .user span,
.modal .content .text .date span {
  font-weight: 700;
}

</style>
